import script from "./PopupTool1.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool1.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool1.vue?vue&type=style&index=0&id=367a90cf&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/u.xiansuotu.com/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-367a90cf"]])

export default __exports__